/**
 * tier-moq-product.js
 */
(function () {

  (function bootstrap() {
    if (window.TIER_MOQ_VARIANTS && window.TIER_MOQ_ENABLED) return;
    var sectionData = document.querySelector(
      '[data-section-type="static-product"][data-section-data]'
    );
    if (!sectionData) return;
    try {
      var parsed = JSON.parse(sectionData.textContent);
      if (parsed.product && parsed.product.variants && parsed.product.variants.length) {
        window.TIER_MOQ_VARIANTS = parsed.product.variants;
        window.TIER_MOQ_ENABLED = true;
      }
    } catch (e) {
      console.warn('[tier-moq] Could not parse section data', e);
    }
  })();

  if (!window.TIER_MOQ_ENABLED) return;

  // ------------------------------------------------------------------
  // DEBUG SWITCH: set to true to stop our script from neutralizing and
  // overwriting Webmaven's native qty-based price text, so you can see
  // exactly what Webmaven outputs on its own (to check if ITS numbers are
  // correct independent of our overwrite). Set back to false to restore
  // normal behavior.
  // ------------------------------------------------------------------
  var DEBUG_DISABLE_OUR_WM_TEXT = false;

  var TIER_SELECT_HINT = 'option-1';
  var initialized = false;

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function neutralizeWmScript() {
    if (DEBUG_DISABLE_OUR_WM_TEXT) return;
    if (window.updateQtyVariant) window.updateQtyVariant = function () {};
    if (window.moqFilterCalculate) window.moqFilterCalculate = function () {};
    if (window.updateQtyBasedPrice) window.updateQtyBasedPrice = function () {};
    // updatePrVariant: found via a live-region diagnostic -- it's a
    // separate Webmaven function (not one of the three above) that
    // mutates .product-pricing[data-product-pricing], which the theme/app
    // marks aria-live="polite" on its own. It also throws an uncaught
    // TypeError partway through, but not before dumping a large, messy
    // block of "Save 0%... Original price $0..." template text into that
    // live region -- competing with our own clean, debounced price
    // announcement and reading as "the price twice" (worse, actually,
    // given how much text it dumps) to screen reader users.
    if (window.updatePrVariant) window.updatePrVariant = function () {};

    // Also blank any text Webmaven already wrote into its elements before
    // we caught it — our own updateWmPriceDisplay will repopulate them.
    var wmEa    = document.getElementById('update-qty-based-ea-wm');
    var wmTotal = document.getElementById('update-qty-based-price-wm');
    if (wmEa && wmEa.textContent)    wmEa.textContent    = '';
    if (wmTotal && wmTotal.textContent) wmTotal.textContent = '';

    // Defensive backstop: strip aria-live from .product-pricing itself,
    // regardless of which script is touching it. This guarantees it can
    // never double-announce alongside our own info block, even if some
    // OTHER Webmaven function we haven't identified yet also writes to it.
    var productPricingEl = document.querySelector('.product-pricing[data-product-pricing]');
    if (productPricingEl && productPricingEl.getAttribute('aria-live')) {
      productPricingEl.removeAttribute('aria-live');
      productPricingEl.removeAttribute('role');
    }
  }
  neutralizeWmScript();
  setTimeout(neutralizeWmScript, 200);
  setTimeout(neutralizeWmScript, 500);
  setTimeout(neutralizeWmScript, 1000);
  setTimeout(neutralizeWmScript, 1500);

  // Sets an aria-label only if the element doesn't already have SOME
  // accessible name (aria-label, aria-labelledby, or an associated
  // <label for>). Never overrides a name the theme already provides --
  // this is purely a safety net for markup that might be missing one.
  function ensureAccessibleName(el, fallbackLabel) {
    if (!el) return;
    if (el.getAttribute('aria-label')) return;
    if (el.getAttribute('aria-labelledby')) return;
    if (el.id && document.querySelector('label[for="' + el.id + '"]')) return;
    el.setAttribute('aria-label', fallbackLabel);
  }

  // Ensures an element that has a click handler is actually keyboard
  // operable. Native <button>/<a>/<input> elements already are; this only
  // steps in for the case where the theme built a control as a plain
  // <div>/<span> with just a click listener, which would be invisible to
  // keyboard-only and screen reader users entirely.
  function ensureKeyboardOperable(el) {
    if (!el) return;
    var tag = el.tagName ? el.tagName.toLowerCase() : '';
    var nativelyFocusable = tag === 'button' || tag === 'a' || tag === 'input';
    if (nativelyFocusable || el.hasAttribute('tabindex')) return;

    el.setAttribute('tabindex', '0');
    if (!el.getAttribute('role')) el.setAttribute('role', 'button');
    el.addEventListener('keydown', function (evt) {
      if (evt.key === 'Enter' || evt.key === ' ') {
        evt.preventDefault();
        el.click();
      }
    });
  }

  function parseTierUnit(label) {
    var slashIdx = label.indexOf('/');
    if (slashIdx !== -1) {
      return label.slice(slashIdx + 1).replace(/[()]/g, '').trim();
    }
    return label.replace(/^[\d\s\-+(),]+/, '').trim();
  }

  // Extracts units-per-case from a container size label. Works with or
  // without a slash after the number.
  // "35g (48/ per case)"  → 48
  // "85g (24 per case)"   → 24
  // "4oz (24/case)"       → 24
  // "100g (12 ct)"        → 12
  // "1 lb (by weight)"    → 1  (each qty unit is already 1 unit)
  function parseUnitsPerCase(containerSizeLabel) {
    if (!containerSizeLabel) return 1;
    if (/by\s*weight/i.test(containerSizeLabel)) return 1;
    var match = containerSizeLabel.match(
      /\(\s*(\d+)\s*(?:\/\s*)?(?:per\s+)?(?:case|cs|ct|count|pk|pack)\b/i
    );
    return match ? parseInt(match[1], 10) : 1;
  }

  // True if the container size label says it's sold by the case,
  // e.g. "85g (24 per case)", "35g (48/ per case)", "4oz (24/case)".
  // A "per case" label is ALWAYS case-based, never by-weight, even if
  // the unit count can't be parsed (or is 1).
  function isCaseBasedLabel(containerSizeLabel) {
    if (!containerSizeLabel) return false;
    return /per\s*case|\/\s*case/i.test(containerSizeLabel);
  }

  // For by-weight containers, extracts the actual weight unit used in the
  // listing (lb, kg, oz, g, ...) instead of assuming "lb". Looks at the
  // portion of the label before any parenthetical, strips the leading
  // number, and returns whatever unit text is left.
  // "1 lb (by weight)"  → { singular: 'lb',  plural: 'lbs' }
  // "5 kg (by weight)"  → { singular: 'kg',  plural: 'kg'  }
  // "16 oz (by weight)" → { singular: 'oz',  plural: 'oz'  }
  function parseWeightUnit(containerSizeLabel) {
    if (!containerSizeLabel) return { singular: 'unit', plural: 'units' };
    var beforeParen = containerSizeLabel.split('(')[0].trim();
    var m = beforeParen.match(/^[\d.,]+\s*(.+)$/);
    var unit = m && m[1] ? m[1].trim() : '';
    if (!unit) return { singular: 'unit', plural: 'units' };
    var lower = unit.toLowerCase();
    var plural = (lower === 'lb' || lower === 'lbs') ? 'lbs' : unit;
    var singular = (lower === 'lb' || lower === 'lbs') ? 'lb' : unit;
    return { singular: singular, plural: plural };
  }

  // Products sold ONLY by price tier -- no separate jar/container size
  // option at all (e.g. "100-249 lbs" / "250-999 lbs" / "1000+ lb") --
  // have no containerSizeLabel for parseWeightUnit() to read a unit from.
  // In that case, fall back to reading the unit straight off the tier
  // label itself via parseTierUnit(), which already strips the leading
  // number/range and returns whatever unit text is left (e.g. "lbs",
  // "lb"). Only used when containerSizeLabel is absent; a real container
  // size label (when present) remains the source of truth.
  function resolveWeightUnit(containerSizeLabel, tierLabel) {
    if (containerSizeLabel) return parseWeightUnit(containerSizeLabel);
    if (tierLabel) {
      var raw = parseTierUnit(tierLabel);
      if (raw) {
        var lower = raw.toLowerCase();
        if (lower === 'lb' || lower === 'lbs') return { singular: 'lb', plural: 'lbs' };
        return { singular: raw, plural: raw };
      }
    }
    return { singular: 'unit', plural: 'units' };
  }

  function init() {
    if (initialized) return;
    initialized = true;

    var tierSelect = findTierSelect();
    var qtyInput = document.querySelector('[name="quantity"]');
    var form = document.querySelector(
      'form[data-productid],form[id^="product_form_"],form[data-type="add-to-cart-form"],form[action*="/cart/add"]'
    );

    if (!tierSelect || !qtyInput) {
      console.warn('[tier-moq] Tier select or quantity input not found.');
      return;
    }

    var allTierOptionEls = Array.prototype.slice.call(tierSelect.querySelectorAll('option'));
    var allTiersByLabel = {};
    allTierOptionEls.forEach(function (opt) {
      var label = opt.value || opt.textContent.trim();
      allTiersByLabel[label] = { label: label, min: parseTierLabel(label).min, max: parseTierLabel(label).max };
    });

    var jarSizeSelect = findJarSizeSelect();

    // Defensive fallback: if the theme's markup doesn't already give
    // these selects an accessible name (no associated <label for>, no
    // aria-label), set one. We can't know for certain from this script
    // alone whether the theme already handles this, so this only fills
    // the gap -- it never overrides an existing label.
    ensureAccessibleName(tierSelect, 'Price tier');
    ensureAccessibleName(jarSizeSelect, 'Container size');

    // Scope tiers immediately before anything else runs
    var priceTiers = computeTiersForJarSize(jarSizeSelect ? jarSizeSelect.value : null);
    if (jarSizeSelect) applyTierScopeToSelect(priceTiers);

    var initialTierValue = tierSelect.value;
    if (!initialTierValue) {
      var firstOpt = tierSelect.querySelector('option');
      initialTierValue = firstOpt ? (firstOpt.value || firstOpt.textContent.trim()) : '';
    }
    var activeTierMin = getTierBounds(initialTierValue).min;
    if (isNaN(activeTierMin) || activeTierMin < 1) activeTierMin = priceTiers[0] ? priceTiers[0].min : 1;

    // ------------------------------------------------------------------
    // Info block: create now if the anchor exists, or watch for it.
    // Either way, populate AFTER syncAll has run so tier/qty are settled.
    // ------------------------------------------------------------------
    ensureInfoBlock();

    // ------------------------------------------------------------------
    // Watch the qty input for external resets (theme variant JS blanking
    // it) and immediately restore our value.
    // ------------------------------------------------------------------
    var guardedQty = activeTierMin;
    var qtyObserver = new MutationObserver(function () {
      if (typing) return;
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || qtyInput.value === '') {
        qtyInput.value = guardedQty;
      }
    });
    qtyObserver.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });

    // Also intercept direct .value writes via property descriptor
    var nativeDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    Object.defineProperty(qtyInput, 'value', {
      get: function () {
        return nativeDescriptor.get.call(this);
      },
      set: function (v) {
        // While the user is actively typing/clearing the field, let blank
        // or in-progress values through untouched -- finalizeTyping() /
        // finalizeOnBlur() resolve the real value once they're done.
        // Only auto-restore guardedQty when something writes a blank/NaN
        // value while the user is NOT typing (i.e. the theme's own JS
        // trying to reset/blank the field out from under us).
        if (typing) {
          nativeDescriptor.set.call(this, v);
          return;
        }
        var num = parseInt(v, 10);
        if (v === '' || isNaN(num) || num < 1) {
          // Theme is trying to blank/reset us — restore guarded value instead
          nativeDescriptor.set.call(this, guardedQty);
        } else {
          guardedQty = num;
          nativeDescriptor.set.call(this, v);
        }
      },
      configurable: true
    });

    syncAll(activeTierMin);

    // Ensure the info block is populated on page load even if the
    // quantity-selector anchor wasn't in the DOM when syncAll ran.
    // Capture the current tier snapshot now so the closure is self-contained.
    (function () {
      var snapTier = null;
      for (var i = 0; i < priceTiers.length; i++) {
        var t = priceTiers[i];
        if (!isNaN(t.min) && activeTierMin >= t.min && (t.max === Infinity || activeTierMin <= t.max)) {
          snapTier = t;
          break;
        }
      }
      if (!snapTier && priceTiers.length) snapTier = priceTiers[0];
      if (!snapTier) return;

      var snapQty = activeTierMin;

      function tryPopulate() {
        ensureInfoBlock();
        if (document.getElementById('tier-moq-info-block')) {
          updateWmPriceDisplay(snapTier, snapQty);
          return true;
        }
        return false;
      }

      if (!tryPopulate()) {
        var attempts = 0;
        var poll = setInterval(function () {
          attempts++;
          if (tryPopulate() || attempts >= 30) clearInterval(poll);
        }, 200);
      }

      // Second pass after 600ms in case Shopify.formatMoney wasn't ready yet
      setTimeout(function () {
        ensureInfoBlock();
        updateWmPriceDisplay(snapTier, snapQty);
      }, 600);
    })();

    // ------------------------------------------------------------------
    // Button guard: watch the ATC button and immediately reverse any
    // "Unavailable" state the theme sets, as long as we have a valid
    // scoped variant. The theme adds class "disabled" and sets
    // btn.disabled = true — we remove both and restore the text.
    // ------------------------------------------------------------------
    var atcBtn = document.querySelector('.product-form--atc-button');
    var buttonGuardActive = false;
    if (atcBtn) {
      new MutationObserver(function () {
        if (!buttonGuardActive) return;
        if (atcBtn.disabled || atcBtn.classList.contains('disabled')) {
          // Find the current valid variant to confirm we should override
          var jarVal = jarSizeSelect ? jarSizeSelect.value : null;
          var tierVal = tierSelect.value;
          var hasValidVariant = false;
          // jarVal is legitimately null on a price-tier-only product
          // with no separate size option (see findJarSizeSelect()) --
          // only tierVal and TIER_MOQ_VARIANTS are actually required.
          if (tierVal && window.TIER_MOQ_VARIANTS) {
            for (var i = 0; i < window.TIER_MOQ_VARIANTS.length; i++) {
              var v = window.TIER_MOQ_VARIANTS[i];
              var opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
              if ((!jarVal || opts.indexOf(jarVal) !== -1) && opts.indexOf(tierVal) !== -1 && v.available) {
                hasValidVariant = true;
                break;
              }
            }
          }
          if (hasValidVariant) {
            atcBtn.disabled = false;
            atcBtn.classList.remove('disabled');
            // Restore button text if theme changed it to "Unavailable"
            var btnText = atcBtn.querySelector('.btn__text, span:not([class])') || atcBtn;
            if (/unavailable/i.test(btnText.textContent)) {
              btnText.textContent = 'Add to cart';
            }
          }
        }
      }).observe(atcBtn, { attributes: true, childList: true, subtree: true });
    }

    // ------------------------------------------------------------------
    // Jar size change
    // ------------------------------------------------------------------
    if (jarSizeSelect) {
      jarSizeSelect.addEventListener('change', function () {
        priceTiers = computeTiersForJarSize(jarSizeSelect.value);
        applyTierScopeToSelect(priceTiers);

        // Activate the button guard so theme can't flip us to Unavailable
        buttonGuardActive = true;

        // Pick first valid tier for the new jar size
        var firstValidOpt = null;
        for (var i = 0; i < allTierOptionEls.length; i++) {
          if (!allTierOptionEls[i].hidden && !allTierOptionEls[i].disabled) {
            firstValidOpt = allTierOptionEls[i];
            break;
          }
        }

        if (firstValidOpt) {
          var newTierLabel = firstValidOpt.value || firstValidOpt.textContent.trim();
          var newTierMin = getTierBounds(newTierLabel).min;
          if (isNaN(newTierMin) || newTierMin < 1) newTierMin = priceTiers[0] ? priceTiers[0].min : 1;

          activeTierMin = newTierMin;
          guardedQty = newTierMin;

          tierSelect.value = newTierLabel;

          // Notify any theme listeners that the tier changed, but suppress
          // our OWN tierSelect 'change' handler below from also firing
          // syncAll. Previously this dispatch re-entered our handler,
          // which called syncAll a second time on top of the manual
          // updateDisplayedPrice() call above -- two back-to-back
          // dispatches onto the hidden variant select raced each other and
          // intermittently left the lowest tier marked "Unavailable" right
          // after a jar size switch.
          suppressTierChangeHandler = true;
          tierSelect.dispatchEvent(new Event('change', { bubbles: true }));
          suppressTierChangeHandler = false;

          // Single source of truth for resolving price + hidden variant
          // select + qty for the new jar size/tier combo.
          syncAll(newTierMin);

          setTimeout(function () { buttonGuardActive = false; }, 500);
        }
      });
    }

    // ------------------------------------------------------------------
    // Tier select change
    // ------------------------------------------------------------------
    var suppressTierChangeHandler = false;
    tierSelect.addEventListener('change', function () {
      if (suppressTierChangeHandler) return;

      var selectedOpt = tierSelect.options[tierSelect.selectedIndex];
      var label = selectedOpt ? (selectedOpt.value || selectedOpt.textContent.trim()) : '';
      var bounds = getTierBounds(label);
      if (isNaN(bounds.min) || bounds.min < 1) return;

      activeTierMin = bounds.min;
      guardedQty = bounds.min;

      var currentQty = parseInt(qtyInput.value, 10);
      var fitsNewTier = !isNaN(currentQty) && currentQty >= bounds.min && (bounds.max === Infinity || currentQty <= bounds.max);
      var target = fitsNewTier ? currentQty : bounds.min;
      syncAll(target);
    });

    // ------------------------------------------------------------------
    // Visually-hidden status region for brief, transient announcements
    // that don't belong permanently in the info block -- currently just
    // the "correcting your quantity before adding to cart" step. This is
    // deliberately separate from the theme's own native "Added to your
    // cart" popup/notification, which stays untouched -- this only fills
    // the silent gap during the ~80-160ms auto-correction window before
    // that native flow takes over.
    // ------------------------------------------------------------------
    function ensureStatusRegion() {
      var existing = document.getElementById('tier-moq-status-region');
      if (existing) return existing;
      var el = document.createElement('div');
      el.id = 'tier-moq-status-region';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.style.cssText = [
        'position: absolute',
        'width: 1px',
        'height: 1px',
        'padding: 0',
        'margin: -1px',
        'overflow: hidden',
        'clip: rect(0,0,0,0)',
        'white-space: nowrap',
        'border: 0'
      ].join(';');
      document.body.appendChild(el);
      return el;
    }

    function announceStatus(message) {
      var el = ensureStatusRegion();
      // Clear first so a repeated identical message still re-announces
      // (aria-live only fires on an actual content change).
      el.textContent = '';
      setTimeout(function () { el.textContent = message; }, 30);
    }

    // Debounced specifically for the price/total info -- rapid quantity
    // changes (holding/repeatedly clicking +/-, or typing) can update the
    // visible numbers many times within a second. Only announce once
    // things have paused for a moment, so screen reader users hear the
    // final settled value instead of every intermediate step.
    var infoAnnounceTimer = null;
    var INFO_ANNOUNCE_DEBOUNCE_MS = 700;

    function scheduleInfoAnnouncement(message) {
      clearTimeout(infoAnnounceTimer);
      infoAnnounceTimer = setTimeout(function () {
        announceStatus(message);
      }, INFO_ANNOUNCE_DEBOUNCE_MS);
    }

    // ------------------------------------------------------------------
    // Self-contained price/MOQ display block — no Webmaven dependency.
    // Injects a <div id="tier-moq-info-block"> directly above the
    // quantity selector. All lines are owned entirely by us.
    // ------------------------------------------------------------------
    function ensureInfoBlock() {
      if (document.getElementById('tier-moq-info-block')) return;

      var qtySelector = document.querySelector('quantity-selector[data-quantity-selector]');
      if (!qtySelector || !qtySelector.parentNode) return;

      var block = document.createElement('div');
      block.id = 'tier-moq-info-block';
      // Deliberately NOT a live region directly -- rapid quantity changes
      // (holding the + button, or clicking it several times fast) were
      // producing a burst of genuinely different values in quick
      // succession, and a live region tries to announce every single
      // intermediate one. Each announcement is technically accurate, but
      // several overlapping ones landing within a second reads as chaotic
      // repetition to a screen reader user. The visible text below still
      // updates instantly (fine for sighted users watching numbers tick
      // up); the screen-reader announcement is handled separately, via a
      // debounced call to announceStatus() below, so only the FINAL
      // settled value gets announced once things pause.
      block.style.cssText = [
        'margin: 0 0 16px',
        'padding: 12px 14px',
        'background: #fff8f8',
        'border: 1px solid #f0d0d0',
        'border-radius: 6px',
        'font-size: 13px',
        'line-height: 1.7',
        'color: #333'
      ].join(';');

      // Line 2: per unit price + total units count
      var line2 = document.createElement('p');
      line2.id = 'tier-moq-line-moq';
      line2.style.cssText = 'margin:0 0 3px;color:#555;font-size:15px;font-weight:600;';

      // Line 3: order total
      var line3 = document.createElement('p');
      line3.id = 'tier-moq-line-total';
      line3.style.cssText = 'margin:0;color:#cc0000;font-size:15px;font-weight:700;';

      block.appendChild(line2);
      block.appendChild(line3);
      qtySelector.parentNode.insertBefore(block, qtySelector);
    }

    // Keep as no-op so existing call sites don't break
    function ensurePerUnitEl() {}

    function ensureMoqAboveQtyEl() {
      if (document.getElementById('tier-moq-forced-reset-notice')) return;
      var qtySelector = document.querySelector('quantity-selector[data-quantity-selector]');
      if (!qtySelector || !qtySelector.parentNode) return;

      var el = document.createElement('div');
      el.id = 'tier-moq-forced-reset-notice';
      // role="alert" -- unlike the routine price/total info block (which
      // is deliberately NOT a live region, see ensureInfoBlock), a forced
      // reset is a discrete, one-off correction directly caused by
      // something the person just did (typed/entered a qty below the
      // MOQ). It deserves an immediate, assertive announcement rather
      // than the debounced polite one used for routine price updates.
      el.setAttribute('role', 'alert');
      el.style.cssText = [
        'display: none',
        'margin: 0 0 10px',
        'font-size: 13px',
        'font-weight: 700',
        'color: #cc0000'
      ].join(';');

      qtySelector.parentNode.insertBefore(el, qtySelector);
    }

    var moqAboveQtyHideTimer = null;

    // Shows "Minimum order quantity: N" briefly (plain red text, no
    // animation) whenever a requested quantity gets forced up to the tier
    // floor -- e.g. typing a number below the MOQ and blurring/hitting
    // Enter, or the +/- buttons. Does nothing on routine syncAll() calls
    // where no correction happened, so it doesn't fire on every ordinary
    // tier/quantity change.
    function updateMoqAboveQtyEl(tier, wasForcedCorrection) {
      ensureMoqAboveQtyEl();
      var el = document.getElementById('tier-moq-forced-reset-notice');
      if (!el || !tier || !wasForcedCorrection) return;

      // Clear first so a repeated identical message still re-announces
      // (role="alert" only fires on an actual content change).
      el.textContent = '';
      el.style.display = 'none';
      setTimeout(function () {
        el.textContent = 'Minimum order quantity: ' + tier.min;
        el.style.display = 'block';
      }, 20);

      clearTimeout(moqAboveQtyHideTimer);
      moqAboveQtyHideTimer = setTimeout(function () {
        el.style.display = 'none';
      }, 2500);
    }

    function formatMoneyCents(cents) {
      var symbol = '';
      var priceEl = document.querySelector('.product__price .price__current .money, .price__current .money, .money');
      if (priceEl) symbol = priceEl.textContent.replace(/[\d,\.\s]+/g, '').trim();
      if (!symbol && window.Shopify && window.Shopify.currency) symbol = window.Shopify.currency.active || '';
      var amount = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return symbol + ' ' + amount;
    }

    function ensureTierTableBlock() {
      if (document.getElementById('tier-moq-table-block')) return;
      var qtySelector = document.querySelector('quantity-selector[data-quantity-selector]');
      if (!qtySelector || !qtySelector.parentNode) return;

      var block = document.createElement('div');
      block.id = 'tier-moq-table-block';
      block.style.cssText = [
        'margin: 0 0 16px',
        'padding: 12px 14px',
        'background: #fff8f8',
        'border: 1px solid #f0d0d0',
        'border-radius: 6px',
        'font-size: 13px',
        'line-height: 1.7',
        'color: #333'
      ].join(';');

      var heading = document.createElement('div');
      heading.id = 'tier-moq-table-heading';
      // inline style set via setAttribute so nothing can override it
      heading.setAttribute('style', 'margin:0 0 8px;font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:0.05em;display:block;color:#1a3a5c;');

      var table = document.createElement('table');
      table.id = 'tier-moq-table';
      table.style.cssText = 'width:100%;border-collapse:collapse;';
      // Associates the visible "Price Tiers — 35g" heading above as this
      // table's accessible name, so screen readers announce it when
      // landing on the table (equivalent to a <caption>, without visually
      // duplicating the heading text).
      table.setAttribute('aria-labelledby', 'tier-moq-table-heading');
      // A plain data table has no focusable content of its own (no
      // links/buttons/inputs in its cells), so Tab-only keyboard
      // navigation skips it entirely by default -- only Browse Mode
      // (arrow-key reading) would ever reach it otherwise. tabindex="0"
      // makes the table itself a real Tab stop.
      table.setAttribute('tabindex', '0');

      var thead = document.createElement('thead');
      var headRow = document.createElement('tr');
      var thRange = document.createElement('th');
      thRange.scope = 'col';
      thRange.textContent = 'Quantity';
      thRange.setAttribute('style', 'padding:4px 8px;text-align:left;font-weight:600;');
      var thPrice = document.createElement('th');
      thPrice.scope = 'col';
      thPrice.textContent = 'Price';
      thPrice.setAttribute('style', 'padding:4px 8px;text-align:right;font-weight:600;');
      headRow.appendChild(thRange);
      headRow.appendChild(thPrice);
      thead.appendChild(headRow);
      table.appendChild(thead);

      var tbody = document.createElement('tbody');
      tbody.id = 'tier-moq-table-body';
      table.appendChild(tbody);

      block.appendChild(heading);
      block.appendChild(table);
      // Insert ABOVE the info block
      var infoBlock = document.getElementById('tier-moq-info-block');
      if (infoBlock && infoBlock.parentNode) {
        infoBlock.parentNode.insertBefore(block, infoBlock);
      } else {
        qtySelector.parentNode.insertBefore(block, qtySelector);
      }
    }

    function updateTierTable(activeTier, containerSizeValue, isByWeight) {
      ensureTierTableBlock();
      var tbody = document.getElementById('tier-moq-table-body');
      if (!tbody || !window.TIER_MOQ_VARIANTS) return;

      while (tbody.firstChild) tbody.removeChild(tbody.firstChild);

      // Heading just shows the container size as listed (e.g. "35g",
      // "1 lb") without guessing at a container noun (jar/shaker/bag/etc.)
      // since that's not something we have reliable data on.
      var sizeBase = containerSizeValue ? containerSizeValue.replace(/\s*\(.*$/, '').trim() : '';
      var headingEl = document.getElementById('tier-moq-table-heading');
      if (headingEl) {
        headingEl.textContent = 'Price Tiers' + (sizeBase ? ' — ' + sizeBase : '');
        headingEl.setAttribute('style', 'margin:0 0 8px;font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:0.05em;display:block;color:#1a3a5c;');
      }

      priceTiers.forEach(function (t) {
        var tierVariant = null;
        for (var i = 0; i < window.TIER_MOQ_VARIANTS.length; i++) {
          var v = window.TIER_MOQ_VARIANTS[i];
          var opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
          if ((!containerSizeValue || opts.indexOf(containerSizeValue) !== -1) && opts.indexOf(t.label) !== -1) {
            tierVariant = v; break;
          }
        }
        if (!tierVariant) return;

        // Computed per-row (not once above the loop) because on a
        // price-tier-only product with no container size, the weight
        // unit is read from EACH tier's own label -- see
        // resolveWeightUnit() -- so it needs the current row's t.label.
        var weightUnit = resolveWeightUnit(containerSizeValue, t.label);
        var caseLabelSingular = isByWeight ? weightUnit.singular : 'case';
        var caseLabelPlural   = isByWeight ? weightUnit.plural   : 'cases';

        var isActive = activeTier && t.label === activeTier.label;
        var rangeLabel = t.max === Infinity
          ? t.min + '+ ' + caseLabelPlural
          : t.min + '–' + t.max + ' ' + caseLabelPlural;
        var priceLabel = formatMoneyCents(tierVariant.price) + ' / ' + caseLabelSingular;

        var tr = document.createElement('tr');
        tr.style.cssText = isActive ? 'background:#fff0f0;border-left:3px solid #cc0000;' : 'border-left:3px solid transparent;';
        // Color alone doesn't convey "this is your current tier" to a
        // screen reader -- aria-current does.
        if (isActive) tr.setAttribute('aria-current', 'true');

        var tdRange = document.createElement('td');
        tdRange.setAttribute('style', 'padding:4px 8px;font-weight:' + (isActive ? '700' : '400') + ';color:' + (isActive ? '#cc0000' : '#444') + ';');
        tdRange.textContent = rangeLabel;

        var tdPrice = document.createElement('td');
        tdPrice.setAttribute('style', 'padding:4px 8px;text-align:right;font-weight:' + (isActive ? '700' : '400') + ';color:' + (isActive ? '#cc0000' : '#444') + ';');
        tdPrice.textContent = priceLabel;

        tr.appendChild(tdRange);
        tr.appendChild(tdPrice);
        tbody.appendChild(tr);
      });
    }

    function updateWmPriceDisplay(tier, qty) {
      if (DEBUG_DISABLE_OUR_WM_TEXT) return;

      ensureInfoBlock();

      var line2 = document.getElementById('tier-moq-line-moq');
      var line3 = document.getElementById('tier-moq-line-total');

      if (!window.TIER_MOQ_VARIANTS || !tier) return;

      var jarSizeSelect = findJarSizeSelect();
      var jarSizeValue  = jarSizeSelect ? jarSizeSelect.value : null;
      var matchedVariant = null;

      for (var i = 0; i < window.TIER_MOQ_VARIANTS.length; i++) {
        var v = window.TIER_MOQ_VARIANTS[i];
        var opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        if (
          (!jarSizeValue || opts.indexOf(jarSizeValue) !== -1) &&
          opts.indexOf(tier.label) !== -1
        ) {
          matchedVariant = v;
          break;
        }
      }

      if (!matchedVariant || !window.Shopify || !window.Shopify.formatMoney) return;

      var unitsPerCase      = parseUnitsPerCase(jarSizeValue);
      var casePriceCents    = matchedVariant.price;
      // A "per case" label is always case-based, regardless of the
      // parsed count. Only non-case labels with a count of 1 (e.g.
      // "1 lb (by weight)") are treated as by-weight.
      var isByWeight        = !isCaseBasedLabel(jarSizeValue) && unitsPerCase === 1;
      var perUnitCents      = isByWeight ? casePriceCents : Math.round(casePriceCents / unitsPerCase);
      var totalUnits        = isByWeight ? qty : qty * unitsPerCase;
      var totalCents        = casePriceCents * qty;
      var weightUnit        = resolveWeightUnit(jarSizeValue, tier.label);
      var caseLabelPlural   = isByWeight ? weightUnit.plural   : 'cases';
      var unitNounSingular  = isByWeight ? weightUnit.singular : 'unit';
      var unitNounPlural    = isByWeight ? weightUnit.plural   : 'units';

      var newLine2Text = formatMoneyCents(perUnitCents) + ' per ' + unitNounSingular + '  ·  ' + totalUnits.toLocaleString() + ' ' + unitNounPlural;
      var newLine3Text = 'Total: ' + formatMoneyCents(totalCents) + ' for ' + qty + ' ' + caseLabelPlural;

      var textChanged = false;
      if (line2 && line2.textContent !== newLine2Text) { line2.textContent = newLine2Text; textChanged = true; }
      if (line3 && line3.textContent !== newLine3Text) { line3.textContent = newLine3Text; textChanged = true; }

      if (textChanged) {
        scheduleInfoAnnouncement(newLine2Text + '. ' + newLine3Text);
      }

      updateTierTable(tier, jarSizeValue, isByWeight);
    }

    function computeTiersForJarSize(jarSizeValue) {
      var allTiers = Object.keys(allTiersByLabel).map(function (k) { return allTiersByLabel[k]; });
      if (!jarSizeValue || !window.TIER_MOQ_VARIANTS) return allTiers;

      var validLabels = {};
      window.TIER_MOQ_VARIANTS.forEach(function (v) {
        var opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        if (opts.indexOf(jarSizeValue) === -1) return;
        opts.forEach(function (optValue) {
          if (allTiersByLabel.hasOwnProperty(optValue)) validLabels[optValue] = true;
        });
      });

      var scoped = allTiers.filter(function (t) { return validLabels[t.label]; });
      return scoped.length > 0 ? scoped : allTiers;
    }

    function applyTierScopeToSelect(scopedTiers) {
      var scopedLabels = {};
      scopedTiers.forEach(function (t) { scopedLabels[t.label] = true; });

      allTierOptionEls.forEach(function (opt) {
        var label = opt.value || opt.textContent.trim();
        opt.hidden = !scopedLabels[label];
        opt.disabled = !scopedLabels[label];
      });

      var selectedOpt = tierSelect.options[tierSelect.selectedIndex];
      var selectedLabel = selectedOpt ? (selectedOpt.value || selectedOpt.textContent.trim()) : null;
      if (!selectedLabel || !scopedLabels[selectedLabel]) {
        for (var i = 0; i < allTierOptionEls.length; i++) {
          var label = allTierOptionEls[i].value || allTierOptionEls[i].textContent.trim();
          if (scopedLabels[label]) {
            tierSelect.value = allTierOptionEls[i].value || allTierOptionEls[i].textContent.trim();
            break;
          }
        }
      }
    }

    var typing = false;
    var debounceTimer = null;
    var DEBOUNCE_MS = 600;

    qtyInput.addEventListener('keydown', function () { typing = true; });
    qtyInput.addEventListener('input', function () {
      typing = true;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        typing = false;
        finalizeTyping();
      }, DEBOUNCE_MS);
    });
    qtyInput.addEventListener('keydown', function (evt) {
      if (evt.key === 'Enter') {
        clearTimeout(debounceTimer);
        typing = false;
        finalizeOnBlur();
      }
    });
    qtyInput.addEventListener('blur', function () {
      clearTimeout(debounceTimer);
      typing = false;
      finalizeOnBlur();
    });

    var plusBtn = document.querySelector('.quantity-selector__button--plus');
    var minusBtn = document.querySelector('.quantity-selector__button--minus');
    ensureAccessibleName(plusBtn, 'Increase quantity');
    ensureAccessibleName(minusBtn, 'Decrease quantity');
    ensureKeyboardOperable(plusBtn);
    ensureKeyboardOperable(minusBtn);
    if (minusBtn) minusBtn.addEventListener('click', function () { setTimeout(finalizeOnBlur, 0); });
    if (plusBtn) plusBtn.addEventListener('click', function () { setTimeout(finalizeOnBlur, 0); });

    function finalizeTyping() {
      typing = false;
      var raw = qtyInput.value;
      if (raw === '') return;
      var requested = parseInt(raw, 10);
      if (isNaN(requested) || requested < 1) requested = activeTierMin;
      // Debounce-driven: a pause doesn't always mean the user is done
      // typing (e.g. typed "6", paused, about to type "5" for "65"). Keep
      // their digits on screen; only correct to MOQ on a true finalize
      // (blur, Enter, +/- buttons, add-to-cart).
      syncAll(requested, { keepUserInput: true });
    }

    function finalizeOnBlur() {
      typing = false;
      var raw = qtyInput.value;
      var requested = raw === '' ? activeTierMin : parseInt(raw, 10);
      if (isNaN(requested) || requested < 1) requested = activeTierMin;
      syncAll(requested);
    }

    var addToCartBtn = form
      ? form.querySelector('button[type="submit"], button[name="add"], .product-form__submit, button[data-add-to-cart]')
      : document.querySelector('button[type="submit"], button[name="add"], .product-form__submit, button[data-add-to-cart]');

    var atcAutoRetryCount = 0;
    var ATC_MAX_AUTO_RETRIES = 2;

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function (evt) {
        clearTimeout(debounceTimer);
        typing = false;

        var current = parseInt(qtyInput.value, 10);
        var correctTier = findTierForQty(isNaN(current) ? activeTierMin : current);
        var tierMismatch = !correctTier || tierSelect.value !== correctTier.label;
        var qtyTooLow = isNaN(current) || (correctTier && current < correctTier.min);

        if (tierMismatch || qtyTooLow) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          // finalizeOnBlur() corrects the tier/variant/qty in the DOM, but
          // does NOT submit anything on its own. Previously the click just
          // stopped here silently -- the person had to notice nothing
          // happened and click Add to Cart a second time. That read as the
          // button freezing/failing. Instead, correct now and automatically
          // re-click once the correction (including the 50ms qty
          // reassertion inside updateDisplayedPrice) has settled, so a
          // single click always results in an actual add. Capped to avoid
          // any possibility of a runaway loop if a correction can't
          // converge.
          finalizeOnBlur();
          announceStatus('Adjusting quantity to match the selected price tier. Adding to cart.');

          if (atcAutoRetryCount < ATC_MAX_AUTO_RETRIES) {
            atcAutoRetryCount++;
            setTimeout(function () {
              addToCartBtn.click();
            }, 80);
          } else {
            atcAutoRetryCount = 0;
            console.warn('[tier-moq] Could not resolve tier/quantity mismatch after retries — click Add to Cart again.');
          }
          return;
        }

        atcAutoRetryCount = 0;
        var qtyToPreserve = current;
        var tierForPreserved = correctTier;

        var priceInput = form ? form.querySelector('input[name="properties[Price]"]') : null;
        if (priceInput) priceInput.remove();

        // Same race condition previously fixed on the jarSizeSelect change
        // handler: dispatching 'change' unsuppressed re-enters our own
        // tierSelect change listener (which calls syncAll -> updateDisplayedPrice
        // -> dispatches change on the hidden variant select), and then the
        // explicit updateDisplayedPrice() call right below fires a SECOND
        // dispatch onto that same hidden select a moment later. The two
        // races intermittently leave the button stuck in an unavailable/
        // processing state, which is why Add to Cart sometimes just freezes
        // without adding anything. Suppress our own handler here too.
        suppressTierChangeHandler = true;
        tierSelect.dispatchEvent(new Event('change', { bubbles: true }));
        suppressTierChangeHandler = false;

        qtyInput.value = qtyToPreserve;
        if (tierForPreserved) updateDisplayedPrice(tierForPreserved);

        injectTierMinProperty(form, activeTierMin);
      }, true);
    }

    if (form) {
      form.addEventListener('submit', function (evt) {
        var current = parseInt(qtyInput.value, 10);
        if (isNaN(current) || current < activeTierMin) {
          evt.preventDefault();
          syncAll(activeTierMin);
          return;
        }
        var priceInput = form.querySelector('input[name="properties[Price]"]');
        if (priceInput) priceInput.remove();
        injectTierMinProperty(form, activeTierMin);
      });
    }

    function syncAll(requestedQty, opts) {
      if (isNaN(requestedQty) || requestedQty < 1) return;
      var tier = findTierForQty(requestedQty);
      if (!tier) return;

      var finalQty = Math.max(requestedQty, isFinite(tier.min) ? tier.min : requestedQty);
      var keepUserInput = opts && opts.keepUserInput && finalQty !== requestedQty;

      if (keepUserInput) {
        // The user may still be mid-typing a longer number (e.g. typed "6",
        // paused, about to type another digit to make "65"). A partial
        // number can spuriously match the wrong tier for the *currently
        // scoped* jar size (e.g. "6" alone matches a low per-case tier even
        // though the user is typing toward "65" for a by-weight tier).
        // Don't touch tierSelect/price/variant based on incomplete input --
        // just remember the corrected fallback qty. The real tier match +
        // all side effects happen once on a true finalize (blur/Enter/+-/
        // add-to-cart), when we know the number is actually final.
        guardedQty = finalQty;
        return;
      }

      activeTierMin = tier.min;
      guardedQty = finalQty;

      // Write directly via native descriptor to bypass our own guard
      nativeDescriptor.set.call(qtyInput, String(finalQty));
      qtyInput.setAttribute('min', tier.min);

      if (tierSelect.value !== tier.label) {
        tierSelect.value = tier.label;
      }

      updateDisplayedPrice(tier);
      if (!typing) {
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateWmPriceDisplay(tier, finalQty);
      updateMoqAboveQtyEl(tier, finalQty > requestedQty);
    }

    function findTierForQty(qty) {
      var match = null;
      for (var i = 0; i < priceTiers.length; i++) {
        var t = priceTiers[i];
        if (isNaN(t.min)) continue;
        if (qty >= t.min && (t.max === Infinity || qty <= t.max)) {
          // Tier ranges can have overlapping boundaries (e.g. "24-48
          // cases" and "48-99 cases" both include 48). At an overlapping
          // boundary, prefer the tier with the higher minimum -- the
          // shopper should land in the better tier they qualify for, not
          // whichever tier happens to be listed first.
          if (!match || t.min > match.min) match = t;
        }
      }
      if (match) return match;
      return priceTiers.reduce(function (acc, t) {
        if (isNaN(t.min)) return acc;
        return (!acc || t.min < acc.min) ? t : acc;
      }, null);
    }

    function findHiddenVariantSelect() {
      // This theme's real hidden variant select is a fixed, identifiable
      // element: <select name="id" class="variant-selection__variants">,
      // whose <option value="..."> values ARE the variant ids directly --
      // there is no data-variant-id attribute. Target it directly instead
      // of guessing via a "biggest select with data-variant-id options"
      // heuristic, which never matches this theme's actual markup and
      // could also mistakenly pick up an unrelated select elsewhere on
      // the page (e.g. a recommended-products widget).
      var scope = form || document;
      return scope.querySelector('select[name="id"].variant-selection__variants')
          || scope.querySelector('select.variant-selection__variants')
          || scope.querySelector('select[name="id"]');
    }

    function updateDisplayedPrice(tier) {
      var jarSizeSelect = findJarSizeSelect();
      // Only TIER_MOQ_VARIANTS is required here. jarSizeSelect being null
      // is valid and expected on a price-tier-only product with no
      // separate jar/container size option (see findJarSizeSelect()) --
      // bailing out on that used to skip this entire function, which is
      // why the main price display and hidden variant select never
      // updated on those products even though the Price Tiers box/table
      // (driven by a different function) updated correctly.
      if (!window.TIER_MOQ_VARIANTS) return;

      var jarSizeValue = jarSizeSelect ? jarSizeSelect.value : null;
      var tierValue = tier.label;
      var matchedVariant = null;

      for (var i = 0; i < window.TIER_MOQ_VARIANTS.length; i++) {
        var v = window.TIER_MOQ_VARIANTS[i];
        var opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        if ((!jarSizeValue || opts.indexOf(jarSizeValue) !== -1) && opts.indexOf(tierValue) !== -1) {
          matchedVariant = v;
          break;
        }
      }

      if (!matchedVariant) {
        console.warn('[tier-moq] No matching variant for', jarSizeValue, '+', tierValue);
        return;
      }

      // Update price display
      var priceEl = document.querySelector('.product__price .price__current .money, .price__current .money');
      if (priceEl && window.Shopify && window.Shopify.formatMoney) {
        priceEl.textContent = formatMoneyCents(matchedVariant.price);
      }

      // Write to input[name="id"] if it exists (some themes use this)
      var variantIdInput = form ? form.querySelector('input[name="id"]') : null;
      if (variantIdInput) variantIdInput.value = matchedVariant.id;

      // THIS IS THE KEY FIX:
      // This theme drives the Add to Cart button state via a hidden
      // <select name="id" class="variant-selection__variants"> whose
      // <option value="..."> values ARE the variant ids directly. Set the
      // matching option as selected and dispatch change so the theme
      // re-evaluates availability.
      var hiddenVariantSelect = findHiddenVariantSelect();
      if (hiddenVariantSelect) {
        var targetValue = String(matchedVariant.id);
        var hasOption = false;
        for (var j = 0; j < hiddenVariantSelect.options.length; j++) {
          if (hiddenVariantSelect.options[j].value === targetValue) { hasOption = true; break; }
        }
        if (hasOption) {
          hiddenVariantSelect.value = targetValue;
          hiddenVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          console.log('[tier-moq] Set hidden variant select to', matchedVariant.id, '(', jarSizeValue, '+', tierValue, ')');
          // Re-assert qty after theme's change handler runs (it may reset it)
          setTimeout(function () {
            nativeDescriptor.set.call(qtyInput, String(guardedQty));
            qtyInput.setAttribute('min', activeTierMin);
          }, 50);
        }
      }
    }

    function findJarSizeSelect() {
      var scope = form || document;
      // Label-text match first -- this is position-independent, unlike
      // the id-based 'option-0' check below. That matters because some
      // products (e.g. by-weight bulk products sold ONLY by price tier,
      // with no separate jar/container size option) have "Select Price
      // Tier" as their ONE AND ONLY option, which Shopify then assigns
      // index 0 -- i.e. its id contains "option-0". The old id-based
      // check here would match that same Price Tier select and return it
      // as the "jar size" select too, so both ended up pointing at the
      // identical DOM node. That collision fed the tier select's own
      // currently-chosen value back into computeTiersForJarSize() as if
      // it were a jar size, which collapsed the scoped tier list down to
      // whichever single tier happened to already be selected -- visible
      // as only one row in the price table and a mismatched value shown
      // in the dropdown.
      var labels = scope.querySelectorAll('.options-selection__select-label');
      for (var j = 0; j < labels.length; j++) {
        // Matches "Jar Size", "Shaker Size", "Container Size", "Bag
        // Size", etc. -- anything ending in "size" -- but explicitly
        // excludes "price tier" so the two never resolve to the same
        // element even if a theme's markup were to label things
        // ambiguously.
        if (/size/i.test(labels[j].textContent) && !/price tier/i.test(labels[j].textContent)) {
          var wrapper = labels[j].closest('.options-selection__select');
          var sel = wrapper ? wrapper.querySelector('select') : null;
          if (sel && sel !== tierSelect) return sel;
        }
      }
      // Id-based fallback, kept for themes/products without the label
      // markup above -- but still guarded against matching tierSelect
      // itself (the single-option, no-jar-size case described above).
      var selects = scope.querySelectorAll('select');
      for (var i = 0; i < selects.length; i++) {
        if (selects[i].id && selects[i].id.indexOf('option-0') !== -1 && selects[i] !== tierSelect) {
          return selects[i];
        }
      }
      // No separate jar/container size option on this product -- that's
      // valid (a price-tier-only, by-weight product). Every caller of
      // this function already treats a null jarSizeSelect/jarSizeValue
      // as "don't scope by size, and don't require the container size to
      // match a variant" -- so returning null here is the correct signal,
      // not an error.
      return null;
    }
  }

  function findTierSelect() {
    var scope = document;
    var labels = scope.querySelectorAll('.options-selection__select-label');
    for (var j = 0; j < labels.length; j++) {
      if (/price tier/i.test(labels[j].textContent)) {
        var wrapper = labels[j].closest('.options-selection__select');
        var sel = wrapper ? wrapper.querySelector('select') : null;
        if (sel) return sel;
      }
    }
    // Id-based fallback (legacy: assumes Price Tier is always the SECOND
    // option, i.e. id contains "option-1"). Only reached if the label
    // match above didn't find anything. This assumption breaks for
    // products where Price Tier is the ONLY option (then it's
    // "option-0", not "option-1") -- the label match above is what
    // correctly handles that case, so this fallback is a safety net for
    // markup variations, not the primary path.
    var selects = scope.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].id && selects[i].id.indexOf(TIER_SELECT_HINT) !== -1) return selects[i];
    }
    return null;
  }

  function getTierBounds(label) { return parseTierLabel(label); }

  function parseTierLabel(label) {
    var plusIndex = label.indexOf('+');
    var hasPlus = plusIndex !== -1;
    var relevantPortion = hasPlus ? label.slice(0, plusIndex) : label;
    var numbers = relevantPortion.match(/\d+/g);
    if (!numbers || numbers.length === 0) return { min: NaN, max: NaN };
    var min = parseInt(numbers[0], 10);
    var max = hasPlus ? Infinity : (numbers.length >= 2 ? parseInt(numbers[1], 10) : min);
    return { min: min, max: max };
  }

  function injectTierMinProperty(form, tierMin) {
    if (!form || isNaN(tierMin)) return;
    var existing = form.querySelector('input[name="properties[_tier_min]"]');
    if (!existing) {
      existing = document.createElement('input');
      existing.type = 'hidden';
      existing.name = 'properties[_tier_min]';
      form.appendChild(existing);
    }
    existing.value = tierMin;
  }
})();